// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__U4Q2v"};